{
  "title": "عملاء المشتريات",
  "searchLabel": "البحث بالاسم أو رقم الهاتف أو رقم المركبة أو نوعها",
  "searchPlaceholder": "البحث بالاسم أو رقم الهاتف أو رقم المركبة أو نوعها...",
  "columns": {
    "name": "الاسم",
    "phone": "رقم الهاتف",
    "vehiclePlate": "رقم المركبة",
    "vehicleType": "نوع المركبة",
    "vehicleNationality": "جنسية المركبة",
    "driverNationality": "جنسية السائق",
    "linkStatus": "حالة الربط",
    "createdBy": "أضيف بواسطة",
    "createdAt": "تاريخ الإضافة"
  },
  "fields": {
    "name": "الاسم",
    "phone": "رقم الهاتف",
    "vehiclePlate": "رقم المركبة",
    "vehicleType": "نوع المركبة",
    "vehicleNationality": "جنسية المركبة",
    "driverNationality": "جنسية السائق",
    "phoneInvalid": "رقم الهاتف غير صالح"
  },
  "drawer": {
    "title": "تعديل عميل المشتريات",
    "phoneHint": "يحفظ الرقم بعد التأكد أنه غير مسجل لعميل آخر في أي نظام"
  },
  "toasts": {
    "updated": "تم تحديث عميل المشتريات بنجاح"
  },
  "empty": {
    "noResults": "لا توجد نتائج",
    "noData": "لا توجد بيانات متاحة"
  }
}
